import { Rows3, Rows2, Rows4 } from "lucide-react";
import { useRowDensity } from "@/lib/useRowDensity";

// Shared segmented control for the global row-density preference.
// Drops into any PageHeader `actions` slot.
const OPTIONS = [
  { key: "compact", icon: Rows4, title: "Compact rows" },
  { key: "cozy", icon: Rows3, title: "Cozy rows" },
  { key: "comfortable", icon: Rows2, title: "Comfortable rows" },
];

export default function RowDensityToggle({ className = "", testid = "density-toggle" }) {
  const { density, setDensity } = useRowDensity();
  return (
    <div
      className={`hidden sm:inline-flex items-center border divide-x ${className}`}
      style={{ borderColor: "var(--ll-border)" }}
      role="group"
      aria-label="Row density"
      data-testid={testid}
    >
      {OPTIONS.map(({ key, icon: Icon, title }) => (
        <button
          key={key}
          type="button"
          onClick={() => setDensity(key)}
          aria-pressed={density === key}
          title={title}
          data-testid={`${testid}-${key}`}
          className={`px-2.5 py-2 text-xs transition-colors ${density === key ? "bg-[#0b5d9e] text-white" : "hover:bg-[var(--ll-mint)]"}`}
          style={{ borderColor: "var(--ll-border)" }}
        >
          <Icon size={14} />
        </button>
      ))}
    </div>
  );
}
